'use strict';
//pikaday
import Pikaday from 'pikaday';
import "pikaday/css/pikaday.css";
//moment
import moment from 'moment';
moment.locale('lt');
//tooltipster
import Tooltipster from 'tooltipster';
import "tooltipster/dist/css/tooltipster.bundle.css";
//vanilla text mask

import {EwSiteApp} from '../app/ewsiteapp';

EwSiteApp.directive('delayedobjectsItemsList', function () {
	return {
		restrict: 'A',
		link: function (scope, element, attr) {
			scope.dataUrl = '';
			scope.saveUrl = '';
			scope.itemsPerPage = 20;

			if (attr.dataUrl && attr.dataUrl !== '') {
				scope.dataUrl = attr.dataUrl;
			}
			if (attr.saveUrl && attr.saveUrl !== '') {
				scope.saveUrl = attr.saveUrl;
			}
			if (attr.itemsPerPage && attr.itemsPerPage !== '' && attr.itemsPerPage > 0) {
				scope.itemsPerPage = parseInt(attr.itemsPerPage, 10);
			}
			scope.loadItems();
		}
	};
});

EwSiteApp.directive('delayedobjectsItemsList', function () {
	return {
		restrict: 'A',
		link: function (scope, element, attr) {
			scope.dataUrl = '';
			scope.saveUrl = '';
			scope.itemsPerPage = 20;

			if (attr.dataUrl && attr.dataUrl !== '') {
				scope.dataUrl = attr.dataUrl;
			}
			if (attr.saveUrl && attr.saveUrl !== '') {
				scope.saveUrl = attr.saveUrl;
			}
			if (attr.itemsPerPage && attr.itemsPerPage !== '' && attr.itemsPerPage > 0) {
				scope.itemsPerPage = parseInt(attr.itemsPerPage, 10);
			}
			scope.loadItems();
		}
	};
});

EwSiteApp.directive('dopopupSelect', dopopupSelect);

dopopupSelect.$inject = ['$timeout'];
function dopopupSelect($timeout) {
	return {
		restrict: 'A',
		link: function (scope, element) {
			$(element).select2({
				minimumResultsForSearch: -1
			});
			scope.$watch('item.service', function () {
				$timeout(function () {
					$(element).trigger('change');
				}, 20);
			});
		}
	};
}

//esopr
// datepicker1esopr: prefers existing UNIX seconds in scope.item.time (if present)
EwSiteApp.directive('datepicker1esopr', function () {
	return {
		restrict: 'A',
		require: 'ngModel',
		link: function (scope, element, attr, ngModel) {
			// decide model mode (unix seconds vs string)
			var isUnix = typeof ngModel.$modelValue === 'number';

			// compute default date
			var defaultDate;
			if (isUnix && ngModel.$modelValue > 0) {
				defaultDate = new Date(ngModel.$modelValue * 1000);
			} else if (scope.item && scope.item.time > 0) {
				defaultDate = new Date(scope.item.time * 1000);
			} else if (typeof ngModel.$modelValue === 'string' && ngModel.$modelValue) {
				defaultDate = new Date(ngModel.$modelValue);
			} else {
				defaultDate = new Date();
			}

			var picker = new Pikaday({
				field: element[0],
				firstDay: 1,
				format: 'YYYY-MM-DD',
				defaultDate: defaultDate,
				setDefaultDate: true,
				showDaysInNextAndPreviousMonths: true,
				i18n: {
					previousMonth: 'Praėjęs mėnesis',
					nextMonth: 'Sekantis mėnesis',
					months: ['Sausis', 'Vasaris', 'Kovas', 'Balandis', 'Gegužė', 'Birželis', 'Liepa', 'Rugpjūtis', 'Rugsėjis', 'Spalis', 'Lapkritis', 'Gruodis'],
					weekdays: ['Sekmadienis', 'Pirmadienis', 'Antradienis', 'Trečiadienis', 'Ketvirtadienis', 'Penktadienis', 'Šeštadienis'],
					weekdaysShort: ['S', 'P', 'A', 'T', 'K', 'P', 'Š']
				},
				onSelect: function (date) {
					// update view text (always formatted)
					var formatted = moment(date).format('YYYY-MM-DD');
					element.val(formatted);

					// update model in the same "shape" it started with
					if (isUnix) {
						ngModel.$setViewValue(Math.floor(date.getTime() / 1000));
					} else {
						ngModel.$setViewValue(formatted);
					}
				}
			});

			// render from model -> input
			ngModel.$render = function () {
				var val = ngModel.$viewValue;
				var date = null;
				if (typeof val === 'number' && val > 0) {
					date = new Date(val * 1000);
				} else if (typeof val === 'string' && val) {
					date = moment(val, ['YYYY-MM-DD', moment.ISO_8601], true).isValid()
							? moment(val).toDate()
							: null;
				}
				if (date) {
					picker.setDate(date, true);
					element.val(moment(date).format('YYYY-MM-DD'));
				}
			};

			scope.$on('$destroy', function () {
				picker.destroy();
			});
		}
	};
});


EwSiteApp.directive('dopopupSelect', [
	'$timeout',
	function ($timeout) {
		return {
			restrict: 'A',
			link: function (scope, element, attr) {
				$(element).select2({});
				scope.$watch('item.car_id', function () {
					scope.classifiededitor.car_id_isdirty = scope.classifiededitor.car_id.$dirty;
					$timeout(function () {
						$(element).trigger('change');
						if (typeof (scope.item.car_id) !== 'undefined') {
							for (var i = 0; i < scope.cars.length; i++) {
								if (scope.cars[i].id == scope.item.car_id) {
									scope.item.fuel_type = scope.cars[i].fuel_type;
									scope.item.car_body_number = scope.cars[i].car_body_number;
									scope.item.user_id = scope.cars[i].user_id;
									$timeout(function () {
										if ($('#fuel_select').length) {
											$('#fuel_select').trigger('change');
										}
									}, 50);
								}
							}
						}
					}, 200);
				});
			}
		};
	}
]);

EwSiteApp.directive('timepicker1', function () {
	return {
		restrict: 'A',
		link: function (scope, element, attr) { }
	};
});

EwSiteApp.directive('checkHoursMax', function () {
	return {
		restrict: 'A',
		require: 'ngModel',
		link: function (s, e, a, ngModel) {
			e.bind('keyup', function (event) {
				if (ngModel.$modelValue > a.max || typeof (ngModel.$modelValue) === 'undefined') {
					event.preventDefault();
					ngModel.$setViewValue(a.max);
					ngModel.$render();
				}
			});
		}
	};
});

EwSiteApp.directive('checkMinutesMax', function () {
	return {
		restrict: 'A',
		require: 'ngModel',
		link: function (s, e, a, ngModel) {
			e.bind('keyup', function (event) {
				if (ngModel.$modelValue > a.max || typeof (ngModel.$modelValue) === 'undefined') {
					event.preventDefault();
					ngModel.$setViewValue(a.max);
					ngModel.$render();
				}
			});
		}
	};
});

EwSiteApp.directive('numberonly', function () {
	return {
		require: 'ngModel',
		restrict: 'A',
		link: function (scope, element, attrs, ctrl) {
			ctrl.$parsers.push(function (input) {
				if (input == undefined)
					return '';
				var inputNumber = input.toString().replace(/[^0-9]/g, '');
				if (inputNumber != input) {
					ctrl.$setViewValue(inputNumber);
					ctrl.$render();
				}
				return inputNumber;
			});
		}
	};
});

EwSiteApp.directive('numbersanddash', function () {
	return {
		require: 'ngModel',
		restrict: 'A',
		link: function (scope, element, attrs, ctrl) {
			ctrl.$parsers.push(function (input) {
				if (input == undefined)
					return '';
				var inputNumber = input.toString().replace(/[^0-9-\.\,a-z]/gi, '');
				if (inputNumber != input) {
					ctrl.$setViewValue(inputNumber);
					ctrl.$render();
				}
				return inputNumber;
			});
		}
	};
});

//esorr

// datepicker1esorr: default to "today" when model is empty; same sync logic
EwSiteApp.directive('datepicker1esorr', function () {
	return {
		restrict: 'A',
		require: 'ngModel',
		link: function (scope, element, attr, ngModel) {
			var isUnix = typeof ngModel.$modelValue === 'number';

			var defaultDate;
			if (isUnix && ngModel.$modelValue > 0) {
				defaultDate = new Date(ngModel.$modelValue * 1000);
			} else if (typeof ngModel.$modelValue === 'string' && ngModel.$modelValue) {
				defaultDate = moment(ngModel.$modelValue, ['YYYY-MM-DD', moment.ISO_8601], true).isValid()
						? moment(ngModel.$modelValue).toDate()
						: new Date();
			} else {
				defaultDate = new Date(); // today
			}

			var picker = new Pikaday({
				field: element[0],
				firstDay: 1,
				format: 'YYYY-MM-DD',
				defaultDate: defaultDate,
				setDefaultDate: true,
				showDaysInNextAndPreviousMonths: true,
				i18n: {
					previousMonth: 'Praėjęs mėnesis',
					nextMonth: 'Sekantis mėnesis',
					months: ['Sausis', 'Vasaris', 'Kovas', 'Balandis', 'Gegužė', 'Birželis', 'Liepa', 'Rugpjūtis', 'Rugsėjis', 'Spalis', 'Lapkritis', 'Gruodis'],
					weekdays: ['Sekmadienis', 'Pirmadienis', 'Antradienis', 'Trečiadienis', 'Ketvirtadienis', 'Penktadienis', 'Šeštadienis'],
					weekdaysShort: ['S', 'P', 'A', 'T', 'K', 'P', 'Š']
				},
				onSelect: function (date) {
					var formatted = moment(date).format('YYYY-MM-DD');
					element.val(formatted);
					if (isUnix) {
						ngModel.$setViewValue(Math.floor(date.getTime() / 1000));
					} else {
						ngModel.$setViewValue(formatted);
					}
				}
			});

			ngModel.$render = function () {
				var val = ngModel.$viewValue;
				var date = null;
				if (typeof val === 'number' && val > 0) {
					date = new Date(val * 1000);
				} else if (typeof val === 'string' && val) {
					date = moment(val, ['YYYY-MM-DD', moment.ISO_8601], true).isValid()
							? moment(val).toDate()
							: null;
				}
				if (date) {
					picker.setDate(date, true);
					element.val(moment(date).format('YYYY-MM-DD'));
				}
			};

			scope.$on('$destroy', function () {
				picker.destroy();
			});
		}
	};
});


EwSiteApp.directive('timepicker1', function () {
	return {
		restrict: 'A',
		link: function (scope, element, attr) { }
	};
});

EwSiteApp.directive('checkHoursMax', function () {
	return {
		restrict: 'A',
		require: 'ngModel',
		link: function (s, e, a, ngModel) {
			e.bind('keyup', function (event) {
				if (ngModel.$modelValue > a.max || typeof ngModel.$modelValue === 'undefined') {
					event.preventDefault();
					ngModel.$setViewValue(a.max);
					ngModel.$render();
				}
			});
		}
	};
});

EwSiteApp.directive('checkMinutesMax', function () {
	return {
		restrict: 'A',
		require: 'ngModel',
		link: function (s, e, a, ngModel) {
			e.bind('keyup', function (event) {
				if (ngModel.$modelValue > a.max || typeof ngModel.$modelValue === 'undefined') {
					event.preventDefault();
					ngModel.$setViewValue(a.max);
					ngModel.$render();
				}
			});
		}
	};
});

EwSiteApp.directive('dopopupSelect', [
	'$timeout',
	function ($timeout) {
		return {
			restrict: 'A',
			link: function (scope, element) {
				$(element).select2({});

				scope.$watch('item.car_id', function () {
					// guard classifiededitor chain
					if (scope.classifiededitor && scope.classifiededitor.car_id) {
						scope.classifiededitor.car_id_isdirty = scope.classifiededitor.car_id.$dirty;
					}

					$timeout(function () {
						$(element).trigger('change');

						// ensure arrays exist
						var cars = Array.isArray(scope.cars) ? scope.cars : [];
						var officesAll = Array.isArray(scope.offices) ? scope.offices : [];

						var hasCarId = scope.item && typeof scope.item.car_id !== 'undefined' && scope.item.car_id !== null;

						// whenever car changes, reset office select if present
						if (scope.item && typeof scope.item.office_id !== 'undefined') {
							scope.item.office_id = null; // not the string 'undefined'
							$timeout(function () {
								if ($('#office_select').length) {
									$('#office_select').trigger('change');
								}
							}, 50);
						}

						if (hasCarId) {
							// filter offices by selected car's provider
							var selectedCar = null;
							for (var i = 0; i < cars.length; i++) {
								if (cars[i].id == scope.item.car_id) {
									selectedCar = cars[i];
									break;
								}
							}
							if (selectedCar) {
								var offices = [];
								for (var o = 0; o < officesAll.length; o++) {
									if (officesAll[o].provider_id == selectedCar.provider_id) {
										offices.push(officesAll[o]);
									}
								}
								scope.offices_select = offices;
							} else {
								// fallback if car list not loaded/missing match
								scope.offices_select = officesAll;
							}
						} else {
							// no car selected → show all offices (or empty)
							scope.offices_select = officesAll;
						}
					}, 200);
				});
			}
		};
	}
]);


//indicators
EwSiteApp.directive('indicatorCategory', [function () {
		return {
			restrict: 'A',
			link: function (scope, element, attr) {
				scope.dataUrl = '';
				scope.storeUrl = '';

				if (angular.isDefined(attr.dataUrl) && attr.dataUrl !== '') {
					try {
						scope.dataUrl = decodeURIComponent(attr.dataUrl);
					} catch (e) {
						scope.dataUrl = attr.dataUrl; // fallback if not URI-encoded
					}
					scope.loadData();
				}

				if (angular.isDefined(attr.storeUrl) && attr.storeUrl !== '') {
					try {
						scope.storeUrl = decodeURIComponent(attr.storeUrl);
					} catch (e) {
						scope.storeUrl = attr.storeUrl;
					}
				}
			}
		};
	}]);

EwSiteApp.directive('inputColorPick', [
	'$document',
	'$timeout',
	function ($document, $timeout) {
		return {
			restrict: 'E',
			scope: {
				itemModel: '=?ngModel'
			},
			templateUrl: function (element, attr) {
				if (angular.isUndefined(attr.templateUrl)) {
					return 'indicators/inputcolorpick.html';
				}
				return attr.templateUrl;
			},
			controller: [
				'$scope',
				'$http',
				function ($scope, $http) {
					$scope.show = false;

					$scope.toggle = function () {
						$scope.show = !$scope.show;
					};

					$scope.close = function () {
						$scope.show = false;
					};

					$scope.setColor = function (value) {
						$scope.itemModel = value;
						$scope.close();
					};

					$scope.isActive = function (value) {
						return $scope.itemModel === value;
					};
				}
			],
			link: function (scope, element) {
				if (angular.isUndefined(scope.itemModel)) {
					scope.itemModel = 'black';
				}
				$document.on('click', function (event) {
					if (!element[0].contains(event.target)) {
						$timeout(function () {
							scope.close();
						}, 50);
					}
				});
			}
		};
	}
]);

//signals
EwSiteApp.directive('popupSelect', [
	'$timeout',
	function ($timeout) {
		return {
			restrict: 'A',
			link: function (scope, element) {
				$(element).select2({
					minimumResultsForSearch: -1
				});
				scope.$watch('item.status', function () {
					$timeout(function () {
						$(element).trigger('change');
					}, 20);
				});
			}
		};
	}
]);